"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGuestRatingText = void 0;

var getGuestRatingText = function getGuestRatingText(rating) {
  var ratingMax = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  if (ratingMax !== 0) {
    var normalizedRating = rating * (10 / ratingMax);

    if (normalizedRating >= 9.5) {
      return 'Exceptional';
    } else if (normalizedRating >= 9) {
      return 'Wonderful';
    } else if (normalizedRating >= 8.5) {
      return 'Excellent';
    } else if (normalizedRating >= 8) {
      return 'Very Good';
    } else if (normalizedRating >= 7) {
      return 'Good';
    } else if (normalizedRating >= 6) {
      return 'Pleasant';
    } else if (normalizedRating >= 5.5) {
      return 'Okay';
    } else if (normalizedRating >= 5) {
      return 'Fair';
    } else if (normalizedRating >= 4) {
      return 'Disappointing';
    } else if (normalizedRating >= 1.5) {
      return 'Poor';
    } else if (normalizedRating >= 0) {
      return 'Very Poor';
    }
  }

  return 'Not Rated';
};

exports.getGuestRatingText = getGuestRatingText;